import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import "./index.css";
import { AuthContextProvider } from "./context/auth-context";
import { QueryClient, QueryClientProvider } from "react-query";
import ErrorBoundry from "./util/ErrorBoundry";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
    },
  },
});
ReactDOM.render(
  <ErrorBoundry>
    <QueryClientProvider client={queryClient}>
      <AuthContextProvider>
        <App />
      </AuthContextProvider>
    </QueryClientProvider>
  </ErrorBoundry>,
  document.getElementById("root")
);
